module.exports = __webpack_public_path__ + "media/img/frontend_application/map/singapore-d4c19f0210cb7b294d88d5abf299f008.webp";